import React, { Component } from "react";
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
import { withRouter } from 'react-router-dom'
import axios from './axios';
class MoveDetailsInput extends Component{
    constructor(props){
        super(props);
        this.state = {
            clientId : '',
            from:{
                street: '',
                unitNumber: '',
                city: '',
                state: '',
                zip: '',
                hasElevator: '',
                flightOfStairs: 0,
            },
            to : {
                street: '',
                unitNumber: '',
                city: '',
                state: '',
                zip: '',
                hasElevator: '',
                flightOfStairs: 0,
            }
            
        };
    }
    componentDidMount(){
        console.log(this.props)
        this.setState({
            clientId : this.props.location.state.clientInfo._id
        })
    }
    handleChange = (event) => {
        this.setState({Value:event.target.value});
      };
      movingDetailsHandler = async () =>{
          console.log(this.state)
         
            let fromDetails = {...this.state.from , hasElevator:this.state.from.hasElevator === 'Yes' ? true : false}
            const toDetails = {...this.state.to , hasElevator:this.state.to.hasElevator === 'Yes' ? true : false}
            this.props.history.push({ pathname: '/reserve', state:{...this.props.location.state, movingToDetails:toDetails, movingFromDetails:fromDetails }});
      }
    render(){
        return(
            <div className="contact-form--1">
                <div className="container">
                    <div className="row row--35 align-items-start">
                        <div className="col-lg-12 order-2 order-lg-1">
                            <div className="section-title text-left mb--50">
                                <h2 className="title">Moving From</h2>
                                
                            </div>
                            <div className="form-wrapper">
                                
                                <form>
                                    <div class="row">
                                        <div class="col-lg-4 col-md-6 col-xs-6">
                                            <label htmlFor="item01">
                                                <input
                                                    type="text"
                                                    name="street"
                                                    id="item01"
                                                    value={this.state.from.street}
                                                    onChange={(e)=>{this.setState({from: {...this.state.from, street:e.target.value}});}}
                                                    placeholder="Street"
                                                />
                                            </label>
                                        </div>
                                        <div class="col-lg-4 col-md-6 col-xs-6">
                                            <label htmlFor="item02">
                                                <input
                                                    type="text"
                                                    name="unitNumber"
                                                    id="item02"
                                                    value={this.state.from.unitNumber}
                                                    onChange={(e)=>{this.setState({from:{...this.state.from , unitNumber:e.target.value}});}}
                                                    placeholder="Unit Number"
                                                />
                                            </label>
                                        </div>
                                    </div>
                                    <div class="row mb--0">
                                        <div class="col-lg-4 col-md-6 col-xs-6">
                                            <label htmlFor="item03">
                                                <input
                                                    type="text"
                                                    name="city"
                                                    id="item03"
                                                    value={this.state.from.city}
                                                    onChange={(e)=>{this.setState({from:{...this.state.from, city:e.target.value}});}}
                                                    placeholder="City"
                                                />
                                            </label>
                                        </div>
                                        <div class="col-lg-4 col-md-6 col-xs-6">
                                            <label htmlFor="item04">
                                                <input
                                                    type="text"
                                                    name="state"
                                                    id="item04"
                                                    value={this.state.from.state}
                                                    onChange={(e)=>{this.setState({from:{...this.state.from, state: e.target.value}});}}
                                                    placeholder="Province/State"
                                                />
                                            </label>
                                        </div>
                                    </div>
                                    <div class="row mb--20">
                                        <div class="col-lg-4 col-md-6 col-xs-6">
                                            <label htmlFor="item05">
                                                <input
                                                    type="text"
                                                    name="zip"
                                                    id="item05"
                                                    value={this.state.from.zip}
                                                    onChange={(e)=>{this.setState({from:{...this.state.from, zip: e.target.value}});}}
                                                    placeholder="Postal code/Zip"
                                                />
                                            </label>
                                        </div>
                                        <div class="col-lg-4 col-md-6 col-xs-6">
                                            <label htmlFor="item06">
                                                <input
                                                    type="number"
                                                    name="staires"
                                                    id="item06"
                                                    value={this.state.from.flightOfStairs}
                                                    onChange={(e)=>{this.setState({from:{...this.state.from,  flightOfStairs: e.target.value}});}}
                                                    placeholder="How many flights of stairs"
                                                />
                                            </label>
                                            
                                            <FormControl component="fieldset">
                                                <FormLabel component="legend">Is there an Elevator?</FormLabel>
                                                <RadioGroup aria-label="gender" name="hasElevatorFrom" value={this.state.from.hasElevator} onChange={(e) => {this.setState({from:{...this.state.from, hasElevator:e.target.value}})}}>
                                                <div class="row" style={{width:'230px'}}>
                                                    <div class="col">
                                                        <FormControlLabel value="Yes" control={<Radio />} label="Yes" />
                                                    </div>
                                                    <div class="col">    
                                                        <FormControlLabel value="No" control={<Radio />} label="No" />
                                                    </div>
                                                </div>
                                                </RadioGroup>
                                            </FormControl>
                                            
                                        </div>
                                    </div>
                                    {/* <label htmlFor="item04">
                                        <textarea
                                            type="text"
                                            id="item04"
                                            name="message"
                                            value={this.state.rnMessage}
                                            onChange={(e)=>{this.setState({rnMessage: e.target.value});}}
                                            placeholder="Your Message"
                                        />
                                    </label> */}
                                    
                                </form>
                            </div>
                        </div>
                        {/* <div className="col-lg-6 order-1 order-lg-2">
                            <div className="thumbnail mb_md--30 mb_sm--30">
                                <img src={`${this.props.contactImages}`} alt="trydo"/>
                            </div>
                        </div> */}
                    </div>
                    <div className="row row--35 align-items-start">
                        <div className="col-lg-12 order-2 order-lg-1">
                            <div className="section-title text-left mb--50 mt--20">
                                <h2 className="title">Moving To</h2>
                                
                            </div>
                            <div className="form-wrapper">
                                
                                <form>
                                    <div class="row">
                                        <div class="col-lg-4 col-md-6 col-xs-6">
                                            <label htmlFor="item08">
                                                <input
                                                    type="text"
                                                    name="street"
                                                    id="item08"
                                                    value={this.state.to.street}
                                                    onChange={(e)=>{this.setState({to:{...this.state.to, street: e.target.value}});}}
                                                    placeholder="Street"
                                                />
                                            </label>
                                        </div>
                                        <div class="col-lg-4 col-md-6 col-xs-6">
                                            <label htmlFor="item09">
                                                <input
                                                    type="text"
                                                    name="unitNumber"
                                                    id="item09"
                                                    value={this.state.to.UnitNumber}
                                                    onChange={(e)=>{this.setState({to:{...this.state.to , unitNumber:e.target.value}});}}
                                                    placeholder="Unit Number"
                                                />
                                            </label>
                                        </div>
                                    </div>
                                    <div class="row mb--0">
                                        <div class="col-lg-4 col-md-6 col-xs-6">
                                            <label htmlFor="item010">
                                                <input
                                                    type="text"
                                                    name="city"
                                                    id="item010"
                                                    value={this.state.to.city}
                                                    onChange={(e)=>{this.setState({to:{...this.state.to, city: e.target.value}});}}
                                                    placeholder="City"
                                                />
                                            </label>
                                        </div>
                                        <div class="col-lg-4 col-md-6 col-xs-6">
                                            <label htmlFor="item011">
                                                <input
                                                    type="text"
                                                    name="state"
                                                    id="item011"
                                                    value={this.state.to.state}
                                                    onChange={(e)=>{this.setState({to:{...this.state.to, state: e.target.value}});}}
                                                    placeholder="Province/State"
                                                />
                                            </label>
                                        </div>
                                    </div>
                                    <div class="row mb--20">
                                        <div class="col-lg-4 col-md-6 col-xs-6">
                                            <label htmlFor="item012">
                                                <input
                                                    type="text"
                                                    name="zip"
                                                    id="item012"
                                                    value={this.state.to.zip}
                                                    onChange={(e)=>{this.setState({to:{...this.state.to, zip: e.target.value}});}}
                                                    placeholder="Postal code/Zip"
                                                />
                                            </label>
                                        </div>
                                        <div class="col-lg-4 col-md-6 col-xs-6">
                                            <label htmlFor="item013">
                                                <input
                                                    type="number"
                                                    name="stairs"
                                                    id="item013"
                                                    value={this.state.to.flightOfStairs}
                                                    onChange={(e)=>{this.setState({to:{...this.state.to,flightOfStairs: e.target.value}});}}
                                                    placeholder="How many flights of stairs"
                                                />
                                            </label>
                                            
                                            <FormControl component="fieldset">
                                                <FormLabel component="legend">Is there an Elevator?</FormLabel>
                                                <RadioGroup aria-label="hasElevatorTo" name="hasElevatorTo" value={this.state.to.hasElevator} onChange={(e) => this.setState({to:{...this.state.to, hasElevator:e.target.value}})}>
                                                <div class="row" style={{width:'230px'}}>
                                                    <div class="col">
                                                        <FormControlLabel value="Yes" control={<Radio />} label="Yes" />
                                                    </div>
                                                    <div class="col">    
                                                        <FormControlLabel value="No" control={<Radio />} label="No" />
                                                    </div>
                                                </div>
                                                </RadioGroup>
                                            </FormControl>
                                            
                                        </div>
                                    </div>
                                    {/* <label htmlFor="item04">
                                        <textarea
                                            type="text"
                                            id="item04"
                                            name="message"
                                            value={this.state.rnMessage}
                                            onChange={(e)=>{this.setState({rnMessage: e.target.value});}}
                                            placeholder="Your Message"
                                        />
                                    </label> */}
                                    <div className="header-btn" >
                                        <button className="rn-btn" onClick={this.movingDetailsHandler} disabled={false} type="button" style={{height:'50px',width: '140px',paddingLeft:'40px',paddingTop:'5px'}}>
                                            <span style={{fontSize:'17px'}}>Submit</span>
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                        {/* <div className="col-lg-6 order-1 order-lg-2">
                            <div className="thumbnail mb_md--30 mb_sm--30">
                                <img src={`${this.props.contactImages}`} alt="trydo"/>
                            </div>
                        </div> */}
                    </div>
                </div>
            </div>
        )
    }
}
export default withRouter(MoveDetailsInput);